module.exports = __webpack_public_path__ + "static/media/ENTERPRISE STRATEGY.9a034de7.svg";